export default {
  data() {
    return {
      selectRow: [],
      tableDefault: {
        tableName: "table" + new Date().getTime(),
        stripe: false, //是否斑马纹
        border: false, //是否带边框
        height: 500, //表格高度 单位px
        fixed: false, //string, boolean  true, left, right true 表示固定在左侧 表格左侧或右侧一列固定
        showSelect: true, // 是否显示选择框
        template: "", //自定义列模板 传入模板名称
        indexShow: false, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        summaryMethod: this.summaryMethod,
      },
      tableRowClassName: ({row, rowIndex}) => {
        // 表格每行样式
        if (rowIndex % 2 === 0) return "";
        else return "singular-row";
      },
    }
  },
  methods: {
    imgNotNull(data) {
      return data !== null && data !== undefined && data !== "" && data !== "--";
    },
    dataNotNull(data) {
      return data !== null && data !== undefined && data !== "";
    },
    getIndex(index) {
      return index + 1 + (this.page.current - 1) * this.page.pageSize;
    },
    //switch修改事件
    switchChange(row, column) {
      column.change && column.change(row);
    },
    //列表行高 表头高度固定
    setTableTrHeight() {
      let searchBox = document.getElementById("searchBox");
      let searchBoxHeight = 0;
      if (searchBox) searchBoxHeight = searchBox.offsetHeight;
      let windowHeight = document.body.clientHeight;
      //窗口可视范围高度-头部高度-页面title高度-content padding -搜索框高度-表头高度
      //表头高度只能在初始化时设置，后面更改无法双向绑定
      let lineHeight =
        (windowHeight - 430 - searchBoxHeight) /
        (11 + (this.tableOptions.showSummary ? 1 : 0));
      if (lineHeight < 32) lineHeight = 32;
      this.rowHeight = (lineHeight - 1).toFixed(2);
      this.maxHeight = lineHeight * 12 + 9
      this.setTableBodyHeight(lineHeight);
    },
    setTableBodyHeight(lineHeight) {
      var style = document.createElement("style"), //创建一个style元素
        head = document.head || document.getElementsByTagName("head")[0]; //获取head元素
      style.setAttribute("id", "tableStyle");
      // let tableBody = `.table-box .el-table__body-wrapper{overflow-y: auto;height:${lineHeight * 10 + 10
      //     }px;}`;
      // //一页十条不做样式处理
      // if (this.page && this.page.pageSize == 10) {
      //     tableBody = '';
      // }
      let tableBody = ''
      let cssText = `${tableBody}
          .table-box .el-table__header-wrapper{height:${lineHeight}px;line-height:${lineHeight}px;}
          .table-box .el-table__footer{height:${lineHeight}px;line-height:${lineHeight}px;}
          .table-box .el-table__fixed-header-wrapper{height:${lineHeight}px;line-height:${lineHeight}px;}`;
      var textNode = document.createTextNode(cssText);
      style.appendChild(textNode);
      head.appendChild(style);
    },
    //点击数据
    itemClick(column, value) {
      column.callback && column.callback(value);
    },
    // 获取枚举值
    getEnumItem(column, data) {
      if (!data) return;
      let enumItem = column.enumData.filter(
        (item) => item.id == data || item.value == data
      );
      if (enumItem.length == 0) {
        return `<span class="status-item">${data}</span>`;
      } else {
        enumItem = enumItem[0];
        return `<span class="status-item ${enumItem.class}">${enumItem.name || enumItem.label
        }</span>`;
      }
    },
    // 自定义值转化
    getSelfItem(column, data) {
      let value;
      switch (data) {
        case true://是
          value = '是'
          break;
        case false://否
          value = '否'
          break;
      }
      return `<span class="status-item">${value}</span>`;
    },
    // 操作回调
    btnCommon(btnObj, data) {
      if (!btnObj.callback) {
        switch (btnObj.code) {
          case "update":
            this.$emit("btnCommon", btnObj, data);
            break;
          case "delete":
            this.delete(data, btnObj);
            break;
          default:
            console.log(btnObj.code);
        }
      } else {
        btnObj.callback && btnObj.callback(data);
      }
    },
    summaryMethod(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        let hasSummary =
          this.tableOptions.summaryColumns.filter((item) => {
            return item == column.property;
          }).length > 0;
        // const values = data.map((item) => Number(item[column.property]));
        // if (!values.every((value) => isNaN(value)) && hasSummary) {
        //     sums[index] = values.reduce((prev, curr) => {
        //         const value = Number(curr);
        //         if (!isNaN(value)) {
        //             return prev + curr;
        //         } else {
        //             return prev;
        //         }
        //     }, 0);
        // } else {
        //     sums[index] = "";
        // }
        if (hasSummary && (this.sumEntity || this.sumEntityChildren)) {
          if (this.sumEntity) {
            sums[index] = this.sumEntity[column.property];
          }
          if (this.sumEntityChildren) {
            sums[index] = this.sumEntityChildren[column.property];
          }
        } else {
          sums[index] = "";
        }
      });
      let keys = Object.keys(sums);
      for (let i = 0; i < keys.length; i++) {
        if (typeof (sums[keys[i]]) == "number")
          sums[keys[i]] = this.$utils.returnFloat(sums[keys[i]]);
      }
      return sums;
    },
    delete(data, btnObj) {
      this.$confirm("是否确认删除当前id为{" + data.id + "}的数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {};
          params[this.tableOptions.uniqueKey || "id"] = data.id;
          this.$axios[btnObj.methods || "fetchDelete"](
            (btnObj.deleteUrl || this.tableOptions.url) +
            "?" +
            (this.tableOptions.uniqueKey || "id") +
            "=" +
            data.id,
            btnObj.methods ? params : {}
          ).then((data) => {
            if (data.code == 200) {
              this.$notify({
                type: "success",
                title: '删除操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({ type: "success", message: "删除成功!" });
              this.getTableData();
            } else {
              // this.$message({message: data.msg, type: "error"});
              this.$notify({
                type: "error",
                title: '删除操作',
                message: '失败',
                showClose: false,
              });
            }
          });
        });
    },
  },
  destroyed() {
    if (this.page && this.page.pageSize == 10) return;
    let head = document.head || document.getElementsByTagName("head")[0]; //获取head元素
    if (document.getElementById('tableStyle')) {
      head.removeChild(document.getElementById('tableStyle'));
    }
  },
}



// WEBPACK FOOTER //
// ./src/mixin/table.js